import { Box } from "@mui/material";

import borderSuccess from "../res/border_succes.png";
import dungeonOff from "../res/emptySlot.png";

export const SuccessImage = ({ src }) => {
  return (
    <Box
      className="centered-background"
      component="img"
      src={borderSuccess}
      sx={{
        height: 1,
        background: `url(${src ?? dungeonOff}) center no-repeat`,
        backgroundSize: "cover",
      }}
    />
  );
};
